import React from 'react';

export default function BudgetLock() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Budget Lock</h1>
      <p className="text-gray-500">Halaman Budget Lock</p>
    </div>
  );
}
